// UI strings for the inflection table's meanings (dictionary/formMeaning.ts): under each form what
// it means, roughly, in Finnish and English. Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const formMeaningsFi = {
  /** The table's switch (aria-pressed). */
  toggle: 'Merkitykset',
  /** Small print under the table's tools while the meanings are shown. */
  note: 'Merkitykset ovat suunnilleen, eivät virallisia käännöksiä.',
};

type FormMeaningsMessages = typeof formMeaningsFi;

export const formMeaningsEn: FormMeaningsMessages = {
  toggle: 'Meanings',
  note: 'The meanings are approximate, not official translations.',
};

// Messages.formMeanings (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('formMeanings', formMeaningsFi, formMeaningsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof formMeaningsFi> {}
}
